import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { ButtonWrapper } from "@insite/mobius/Button";
import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import { InputStyle } from "@insite/mobius/TextField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

if (filtersAccordionStyles.accordion) {
    filtersAccordionStyles.accordion.css = css`
        border-bottom: 4px solid ${getColor("common.border")};
        & dl {
            flex-basis: 100%;
        }
        & dt {
            height: 48px;
            button {
                background-color: ${getColor("info.contrast")};
                border: 1px solid ${getColor("common.border")};
                border-radius: 0px;
                padding: 11px 15px;
                border-top: none;
                &:focus {
                    padding: 11px 15px !important;
                    border: 1px solid ${getColor("common.border")};
                    border-top: none;
                }
                & span {
                    &:first-child {
                        font-size: 16px;
                        line-height: 18px;
                        color: ${getColor("secondary")};
                        font-weight: 700;
                        &:hover {
                            color: #163061; //primary hover
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                font-size: 11px;
                            `,
                            null,
                            null,
                        ])}
                }
                svg {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                        ])}
                }
            }
        }
        & dd {
            background-color: ${getColor("info.contrast")};
            border: 1px solid ${getColor("common.border")};
            padding: 11px 15px 5px;
            border-top: none;
            > ${CheckboxGroupStyle} {
                > ${TypographyStyle} {
                    &:first-child {
                        margin-bottom: 0px;
                    }
                }
            }
            span[role="checkbox"] {
                background-color: ${getColor("primary.contrast")};
                border-radius: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            margin-top: 0px;
                        `,
                        null,
                        null,
                    ])}
            }
            & label {
                font-size: 14px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            font-size: 11px;
                        `,
                        null,
                        null,
                    ])}
            }
        }
    `;
}

searchWithinStyles.wrapper = {
    css: css`
        padding: 11px 15px 18px;
        border: 1px solid ${getColor("common.border")};
        background-color: ${getColor("primary.contrast")};
    `,
};

searchWithinStyles.titleText = {
    variant: "h6",
    css: css`
        margin-bottom: 6px;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: {
        src: Search,
        css: css`
            color: ${getColor("text.accent")};
        `,
    },
    cssOverrides: {
        formField: css`
            width: 100%;
            > ${FormInputWrapper} {
                > ${InputStyle} {
                    font-size: 14px;
                    padding: 12px 35px 12px 10px;
                    background-color: ${getColor("primary.contrast")};
                    &:focus {
                        padding: 12px 35px 12px 10px;
                        background-color: ${getColor("primary.contrast")};
                    }
                }
            }
        `,
    },
};

if (filterListStyles.wrapper) {
    filterListStyles.wrapper.css = css`
        padding: 0px 15px;
        border: 1px solid ${getColor("common.border")};
        border-top: none;
        background-color: ${getColor("info.contrast")};
        > div[class^="TagStyle"] {
            background-color: ${getColor("info.contrast")};
            color: ${getColor("secondary")};
            padding: 0;
            flex-direction: row-reverse;
            justify-content: flex-end;
            > ${ButtonWrapper} {
                background: ${getColor("info.contrast")};
                min-height: 25px;
                margin-right: 5px;
                &:hover {
                    background: ${getColor("info.contrast")};
                }
                > ${IconWrapper} {
                    color: ${getColor("secondary")};
                    height: 25px;
                    width: 20px;
                }
            }
        }
        >${StyledButton}{
            >${TypographyStyle}{
                color: ${getColor("secondary")};
            }
        }
    `;
}

filterListStyles.filterText = {
    variant: "h3",
    css: css`
        display: none;
    `,
};